import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { FluentProvider, Spinner } from '@fluentui/react-components'
import { appTheme } from './lib/theme'
import { bootstrap } from './api/client'
import App from './App.tsx'
import { StandaloneDocumentView } from './components/StandaloneDocumentView'

const root = createRoot(document.getElementById('root')!)

// Full-screen document view (item 2, C7, 2026-08-13). There is no router in
// this app (see app/README.md and CLAUDE.md's `NavValue` string-union note) —
// so the "Full Screen" button in PdfPane opens THIS SAME origin with a
// `?doc=<invoiceId>` query parameter, and this branch, checked before the
// normal app shell mounts, recognizes it and renders the pane full-viewport
// instead. Same component, same page-span restriction as the modal, fed by
// its own round trip to `getInvoice`/`getUpload` — the new tab never receives
// the signed upload URL from its opener, it asks the API for its own.
function docIdFromLocation(): string | null {
  return new URLSearchParams(window.location.search).get('doc')
}

// Read the runtime configuration and complete sign-in before the app renders —
// nothing in the shell has to cope with "not signed in yet". A failure here is
// terminal and says so: there is no usable read-only mode behind it.
root.render(
  <StrictMode>
    <FluentProvider theme={appTheme} style={{ minHeight: '100vh' }}>
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <Spinner label="Signing in…" />
      </div>
    </FluentProvider>
  </StrictMode>,
)

bootstrap().then(
  () => {
    const docId = docIdFromLocation()
    root.render(
      <StrictMode>
        <FluentProvider theme={appTheme} style={{ minHeight: '100vh' }}>
          {docId ? <StandaloneDocumentView invoiceId={docId} /> : <App />}
        </FluentProvider>
      </StrictMode>,
    )
  },
  (e: unknown) => {
    const message = e instanceof Error ? e.message : String(e)
    root.render(
      <StrictMode>
        <FluentProvider theme={appTheme} style={{ minHeight: '100vh' }}>
          <div style={{ padding: 32, maxWidth: 640 }}>
            <h2>Accounts Payable could not start</h2>
            <p>{message}</p>
            <p>Reload the page. If it keeps happening, tell the administrator what this said.</p>
          </div>
        </FluentProvider>
      </StrictMode>,
    )
  },
)
